import React from 'react';
import { Reveal } from './Reveal';
export function RevealSection() {
  return <section className="border-y border-white/[0.16] bg-espresso-2 py-[90px] text-center" data-id="element-117">
      <div className="mx-auto max-w-[1100px] px-6" data-id="element-118">
        <Reveal data-id="element-119">
          <h2 className="mx-auto max-w-[780px] text-[clamp(26px,4.4vw,44px)] leading-[1.12] text-white" data-id="element-120">
            ES LO QUE YA TOMÁS TODOS LOS DÍAS —{' '}
            <span className="text-camel" data-id="element-121">PERO AHORA TE RINDE MÁS.</span>
          </h2>
        </Reveal>
        <Reveal data-id="element-122">
          <p className="mx-auto mt-[22px] max-w-[480px] text-base font-semibold text-white/70" data-id="element-123">
            Cofit se suma a tu desayuno de todos los días sin agregar pasos. Sin
            blender, sin shaker, sin complicarte.
          </p>
        </Reveal>
      </div>
    </section>;
}